import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import update from 'immutability-helper';
import TagsInput from 'react-tagsinput';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import MakeModelVariantField from '../misc/MakeModelVariantField.js';
// Style
import 'react-tagsinput/react-tagsinput.css';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('nb', dpLocale);

class Giftcard extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleMakeModelVariantChange = this.handleMakeModelVariantChange.bind(this);
    this.handleModelNamesChange = this.handleModelNamesChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      giftcard: {}
    };

    change.giftcard[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      giftcard: {}
    };

    if (e.target.type === 'checkbox') {
      newData.giftcard[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.giftcard[e.target.name] = {
        $set: e.target.value
      };
    }

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleTagClick(e, tag) {
    e.preventDefault();

    const newData = {
      giftcard: {}
    };

    const tagsArray = this.props.giftcard.modelNames;

    if (tagsArray.includes(tag)) {
      return;
    }

    tagsArray.push(tag);

    newData.giftcard.modelNames = {
      $set: tagsArray
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  handleModelNamesChange(tagsArray) {
    const newData = {
      giftcard: {
        modelNames: {
          $set: tagsArray
        }
      }
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  handleDateChange(date, inputName) {
    // TODO: https://github.com/Hacker0x01/react-datepicker/issues/1018
    // Fix issue with date being a day off by setting hour to after midnight,
    // we only use the date anyway.
    // Note: Only seems to be an issue where the field is set to "Date only" in contentful :S
    if (date) {
      date.setHours(2);
    }

    const elem = {
      target: {
        name: inputName,
        value: date
      }
    };
    this.handleFieldChange(elem);
  }

  handleMakeModelVariantChange(selections) {
    const change = {
      giftcard: {}
    };

    change.giftcard['makes'] = {
      $set: selections.makes
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  render() {
    const giftcard = this.props.giftcard;

    let mmvCls = 'success';
    if (!giftcard.makes) {
      mmvCls = 'default';
    } else if (giftcard.model) {
      if (!giftcard.model.published) {
        mmvCls = 'warning';
      } else if (giftcard.model.updated) {
        mmvCls = 'info';
      }
    }

    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/giftcards/">Gavekort</Link></li>
          {giftcard.title &&
              <li className="active">{giftcard.title}</li>
          }
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="pull-right">
              {this.props.working &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
              }
              {!giftcard.archived &&
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  {Boolean(giftcard.id) &&
                    <span>Lagre</span>
                  }
                  {!giftcard.id &&
                    <span>Opprett gavekort</span>
                  }
                </button>
              }
              &nbsp;
              {giftcard.id && <React.Fragment>
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(giftcard.published && !giftcard.updated) || giftcard.archived || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onPublish();
                  }}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={giftcard.draft || this.props.working || this.props.modified || giftcard.archived}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onUnpublish();
                    if (giftcard.archived) {
                      this.props.onUnarchive();
                    }
                  }}
                >
                  <span>Kladd</span>
                </button>
                &nbsp;
                {!giftcard.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                &nbsp;
                {giftcard.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnarchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </React.Fragment>}
            </div>
            <h1>
              {giftcard.title} <PublishStatusDot entry={giftcard} />
              {giftcard.id && <small> (ID: {giftcard.id})</small>}
              <br/>
            </h1>
          </div>



          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <ul className="nav nav-tabs" role="tablist">
            <li role="general" className="active">
              <a href="#general" aria-controls="general" role="tab" data-toggle="tab">Generelt</a>
            </li>
            <li role="carlink">
              <a href="#carlink" aria-controls="carlink" role="tab" data-toggle="tab">Bilutvalg</a>
            </li>
          </ul>

          <div className="tab-content mf-margin-bottom-40">
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Tittel <em className="small text-muted">(Påkrevet)</em></label>
                    <input type="text" className="form-control" name="title" defaultValue={giftcard.title} onChange={this.handleFieldChange} disabled={this.props.working || giftcard.archived} />
                  </div>

                  <div className="form-group">
                    <label>Beskrivelse / kort tekst</label>
                    <textarea
                      className="form-control"
                      name="description"
                      rows="4"
                      value={giftcard.description}
                      onChange={this.handleFieldChange}
                      disabled={this.props.working || giftcard.archived}
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>Gyldig frem til</label>
                    <div>
                      <DatePicker
                        name="expires"
                        id="expires"
                        disabled={this.props.working || giftcard.archived}
                        className="form-control"
                        locale="nb"
                        dateFormat="dd.MM.yyyy"
                        selected={giftcard.expires}
                        onChange={(e) => this.handleDateChange(e, 'expires')}
                      />
                    </div>
                  </div>
                  <div className="form-group mf-padding-top-20">
                    <label>Gyldig i antall måneder etter aktivering</label>
                    <span id="helpBlock" className="help-block">(Et gavekort blir &quot;aktivert&quot; når brukeren logger inn og ser gavekortet for første gang)</span>
                    <div>
                      <input
                        name="validMonths"
                        id="validMonths"
                        type="number"
                        min="0"
                        disabled={this.props.working || giftcard.archived}
                        className="form-control"
                        selected={giftcard.validMonths}
                        defaultValue={giftcard.validMonths}
                        onChange={this.handleFieldChange}
                      />
                    </div>
                    <span id="helpBlock" className="help-block">Om dette er satt så vil et gavekort være gyldig i X antall måneder etter aktivering (Gavekortet må alikevel aktiveres innen &quot;Gyldig frem til&quot; datoen)</span>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <div className="checkbox mf-margin-bottom-20">
                    <label>
                      <input type="checkbox" name="availableInForms" defaultChecked={giftcard.availableInForms} disabled={this.props.working || giftcard.archived} onChange={this.handleFieldChange} />
                      Gavekortet kan brukes i skjemaer
                    </label>
                  </div>
                  {giftcard.availableInForms && <div className="form-group">
                    <label>Begrens til én skjematype</label>
                    <select
                      className="form-control"
                      name="service"
                      defaultValue={giftcard.service}
                      disabled={this.props.working || giftcard.archived}
                      onChange={this.handleFieldChange}
                    >
                      <option value="">-- Alle --</option>
                      <option value="EU-kontroll (PKK)">EU-kontroll (PKK)</option>
                      <option value="Service">Service</option>
                      <option value="Hjulskift">Hjulskift</option>
                      <option value="Skade">Skade</option>
                      <option value="Aircondition service">Aircondition service</option>
                      <option value="Bytte frontrute">Bytte frontrute</option>
                      <option value="Annet">Annet</option>
                    </select>
                  </div>}
                  <div className="checkbox mf-margin-bottom-20">
                    <label>
                      <input type="checkbox" name="availableAtDealer" defaultChecked={giftcard.availableAtDealer} disabled={this.props.working || giftcard.archived} onChange={this.handleFieldChange} />
                      Gavekortet kan brukes hos forhandler
                    </label>
                  </div>
                  <div className="form-group mf-margin-top-20">
                    <label>Internt navn/kommentar</label>
                    <input type="text" className="form-control" name="internalComment" defaultValue={giftcard.internalComment} onChange={this.handleFieldChange} disabled={this.props.working || giftcard.archived} />
                    <span id="helpBlock" className="help-block">Koden som vil bli lagt ved internt for skjema innsending. Om denne ikke er satt brukes tittel istedenfor</span>
                  </div>
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="carlink">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="form-group">
                    <label>Begrenset til merke</label>
                    <MakeModelVariantField
                      onChange={this.handleMakeModelVariantChange}
                      cls={mmvCls}
                      value={{
                        makes: giftcard.makes || null
                      }}
                    />
                  </div>
                  <div className="form-group mf-margin-top-20">
                    <label>Begrenset til modellnavn</label>
                    <TagsInput
                      addOnBlur={true}
                      value={giftcard.modelNames}
                      onChange={this.handleModelNamesChange}
                      className="react-tagsinput form-control"
                      addKeys={[9, 13, 188]}
                      inputProps={{placeholder: 'modellnavn'}}
                    />
                    <div className="mf-margin-top-10">
                      {this.props.modelNames && this.props.modelNames.map((tag, i) => {
                        return <span key={i}><a onClick={(e) => this.handleTagClick(e, tag)} className="label label-primary">{tag}</a> </span>;
                      })}
                    </div>
                  </div>
                  <div className="form-group mf-margin-top-20">
                    <label>Begrens på garanti</label>
                    <div className="input-group">
                      <input type="number" className="form-control" min="0" name="yearNumber" defaultValue={giftcard.yearNumber} onChange={this.handleFieldChange} disabled={this.props.working || giftcard.archived} />
                      <div className="input-group-addon">ÅR</div>
                    </div>
                    <span id="helpBlock" className="help-block">Bilgarantiens varighet</span>
                    <div className="checkbox mf-margin-top-20">
                      <label>
                        <input type="checkbox" name="yearOutside" defaultChecked={giftcard.yearOutside} disabled={this.props.working || giftcard.archived} onChange={this.handleFieldChange} />
                        Gavekortet gjelder utenfor garantien
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

Giftcard.defaultProps = {
  giftcard: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default Giftcard;
